import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

/**
 * Check if JWT token is expired by decoding its payload.
 * Returns true if token is missing, malformed, or expired.
 */
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    // exp is in seconds, Date.now() is in milliseconds
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      return true;
    }
    return false;
  } catch {
    return true;
  }
};

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = Cookies.get("chatToken");

  if (!token || isTokenExpired(token)) {
    // Clear expired token cookie
    if (token) Cookies.remove("chatToken");
    // Preserve both pathname and query params (e.g., ?source=career_page&sourceChannel=facebook)
    localStorage.setItem("redirectPath", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
